module.exports = __webpack_public_path__ + "img/FGr_Ölschaden_C.9e9abde5.svg";